var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "campaigns-testimonial" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "swiper",
            rawName: "v-swiper:mySwiper",
            value: _vm.swiperOption,
            expression: "swiperOption",
            arg: "mySwiper"
          }
        ],
        staticClass: "swiper-container"
      },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.campaign.testimonials, function(testimonial, index) {
            return _c("div", { key: index, staticClass: "swiper-slide" }, [
              testimonial.imageSrc !== undefined
                ? _c(
                    "figure",
                    { staticClass: "campaigns-testimonial__image" },
                    [
                      _c("picture", [
                        _c("source", {
                          attrs: {
                            "data-srcset": _vm.getImageSrcset(testimonial)
                          }
                        }),
                        _c("img", {
                          staticClass: "lazyload",
                          attrs: {
                            "data-sizes": "auto",
                            "data-src": _vm.getImageSrc(testimonial)
                          }
                        })
                      ])
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "campaigns-testimonial__content" }, [
                _vm._v(
                  "\n          " + _vm._s(testimonial.content) + "\n        "
                )
              ]),
              _c("div", { staticClass: "campaigns-testimonial__author" }, [
                _vm._v(
                  "\n          " + _vm._s(testimonial.author) + "\n        "
                )
              ])
            ])
          }),
          0
        ),
        _c("div", {
          staticClass: "swiper-pagination swiper-pagination-bullets"
        })
      ]
    ),
    _c(
      "div",
      { staticClass: "campaigns-testimonial__action" },
      [
        _c(
          "button-view",
          {
            attrs: { variant: "title" },
            nativeOn: {
              click: function($event) {
                return _vm.scrollToForm()
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.campaign.button) + "\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3539f1f9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3539f1f9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaigns/campaigns-testimonial-view.vue
// module id = 613
// module chunks = 44